import { useState } from 'react';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import api from '../services/api';

// The training platform's in-app home. Trainees never see this page — they enter
// with personal magic links. This is the grant-guarded door for STAFF: the admin
// screen itself is a plain static page authenticated by a signed staff link, and
// the button below mints that link through the (Cognito-guarded) backend — so
// dashboard permissions still decide who can administer the training.
//
// 2026-08-14: the platform moved off the laptop and into this backend
// (/api/training/*), so the admin link works wherever the API works.

const PREVIEW_URL = process.env.REACT_APP_TRAINING_URL
  ? `${process.env.REACT_APP_TRAINING_URL}?preview=1`
  : 'http://localhost:5173/training?preview=1';

export default function TrainingPage() {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const openAdmin = async () => {
    setBusy(true);
    setErr('');
    try {
      const { data } = await api.post('/api/training/admin-link');
      const base = process.env.REACT_APP_API_URL || '';
      window.open(base + data.url, '_blank', 'noreferrer');
    } catch {
      setErr('לא הצלחנו להנפיק קישור ניהול — ודאו שיש לכם הרשאת עריכה להכשרה.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden" dir="rtl">
        <Header title="הכשרה · פלטפורמת ההדרכה" />
        <main className="flex-1 overflow-y-auto p-6">
          <div className="mx-auto max-w-3xl space-y-5">
            <div className="rounded-2xl bg-white p-6 shadow-sm border">
              <h1 className="text-xl font-semibold text-gray-800">🎓 פלטפורמת ההכשרה למטפלים</h1>
              <p className="mt-1 text-sm text-gray-500">
                הכשרת מטפלים חדשים: מסלול מודרך עם סרטונים, תרגולים ומבחנים — וספרייה פתוחה לצוות הוותיק.
                מתלמדים נכנסים עם קישור אישי שנשלח אליהם במייל; ההתקדמות והפעילות נשמרות אוטומטית.
              </p>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <button
                onClick={openAdmin}
                disabled={busy}
                className="rounded-2xl bg-white p-6 shadow-sm border hover:border-indigo-300 hover:shadow transition text-right disabled:opacity-60"
              >
                <div className="text-3xl">🗂️</div>
                <div className="mt-2 text-base font-semibold text-gray-800">
                  {busy ? 'פותח…' : 'מסך הניהול'}
                </div>
                <p className="mt-1 text-sm text-gray-500">
                  יצירת מתלמדים וקישורים אישיים · העלאת סרטונים וחומרים · מעקב התקדמות · שאלות מהמתלמדים
                </p>
              </button>
              <a
                href={PREVIEW_URL}
                target="_blank"
                rel="noreferrer"
                className="rounded-2xl bg-white p-6 shadow-sm border hover:border-indigo-300 hover:shadow transition"
              >
                <div className="text-3xl">📚</div>
                <div className="mt-2 text-base font-semibold text-gray-800">תצוגה מקדימה של ההכשרה</div>
                <p className="mt-1 text-sm text-gray-500">
                  חוויית המתלמד במצב סקירה — כל התחנות פתוחות לדפדוף, עריכת תכנים והעלאת חומרים מתוך השיעורים
                </p>
              </a>
            </div>

            {err && (
              <div className="rounded-xl bg-red-50 border border-red-200 p-4 text-sm text-red-700">{err}</div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
